export const DS_OPTION_LIST_CLASSES = {
  base: "ds-option-list",
  item: "ds-option-list__item",
  groupItem: "ds-option-list__group-item",
  groupOptions: "ds-option-list__group-options",
  optionContent: "ds-option-list__option-content",
  avatar: "ds-option-list__avatar",
  icon: "ds-option-list__icon",
  details: "ds-option-list__details",
  text: "ds-option-list__text",
  description: "ds-option-list__description",
  suffix: "ds-option-list__suffix",
  selected: "ds-option-list__item--selected",
  hoverable: "ds-option-list__item--hoverable",
  focused: "ds-option-list__item--focused",
  disabled: "ds-option-list__item--disabled",
} as const;
